import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MyIcon from '../../../components/general/icon'
import AddAlumniOrganizationCategoty from './add'
import EditAlumniOrganizationCategoty from './edit'
import DeleteAlumniOrganizationCategoty from './delete'

export default function AlumniOrganizationCategoty() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [alumniOrganizationCategotyList, setAlumniOrganizationCategotyList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [isAddAlumniOrganizationCategotyVisible, setIsAddAlumniOrganizationCategotyVisible] = useState(false)
  const [isEditAlumniOrganizationCategotyVisible, setIsEditAlumniOrganizationCategotyVisible] = useState(false)
  const [isDeleteAlumniOrganizationCategotyVisible, setIsDeleteAlumniOrganizationCategotyVisible] = useState(false)

  const getAlumniOrganizationCategotyList = () => {
    axios.post('/p/alumni/organization_categoty/list/get', {
      merchant_oid: merchantOid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAlumniOrganizationCategotyList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniOrganizationCategotyList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const editAlumniOrganizationCategoty = (oid) => {
    setIsEditAlumniOrganizationCategotyVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteAlumniOrganizationCategoty = (oid, name) => {
    setIsDeleteAlumniOrganizationCategotyVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">组织分类</div>
        </div>

        <div className='public-main-style'>
          <div className='public-main-style1'>
            <div className='public-main-style1-add' onClick={() => { setIsAddAlumniOrganizationCategotyVisible(true) }}>
              <div className='public-main-style1-add-icon'>
                <MyIcon name='jiahao' />
              </div>
              <div className='public-main-style1-add-title'>创建新的分类</div>
            </div>

            {alumniOrganizationCategotyList.map(alumniOrganizationCategoty => (
              <div className='public-main-style1-content' key={alumniOrganizationCategoty.oid} onClick={() => { editAlumniOrganizationCategoty(alumniOrganizationCategoty.oid) }}>
                <div>
                  <div className='public-main-style1-content-title'>
                    <div className='public-main-style1-content-name'>{alumniOrganizationCategoty.name}</div>
                    <div className='public-main-style1-content-delete' 
                      onClick={(event) => {event.stopPropagation(); deleteAlumniOrganizationCategoty(alumniOrganizationCategoty.oid, alumniOrganizationCategoty.name)}}>
                      <MyIcon name='huishouzhan' />
                    </div>
                  </div>
                </div>
                <div className='public-main-style1-content-other'>
                  <div className='public-main-style1-content-other-left'>
                    下设 {alumniOrganizationCategoty.organization_number} 个组织
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isAddAlumniOrganizationCategotyVisible && <AddAlumniOrganizationCategoty
        getAlumniOrganizationCategotyList={getAlumniOrganizationCategotyList} 
        isOpen={isAddAlumniOrganizationCategotyVisible} 
        isCancel={() => { setIsAddAlumniOrganizationCategotyVisible(false) }} 
      />}

      {isEditAlumniOrganizationCategotyVisible && <EditAlumniOrganizationCategoty
        data={propsData}
        getAlumniOrganizationCategotyList={getAlumniOrganizationCategotyList}
        isOpen={isEditAlumniOrganizationCategotyVisible}
        isCancel={() => { setIsEditAlumniOrganizationCategotyVisible(false) }}
      />}

      {isDeleteAlumniOrganizationCategotyVisible && <DeleteAlumniOrganizationCategoty
        data={propsData}
        getAlumniOrganizationCategotyList={getAlumniOrganizationCategotyList}
        isOpen={isDeleteAlumniOrganizationCategotyVisible}
        isCancel={() => { setIsDeleteAlumniOrganizationCategotyVisible(false) }}
      />}
    </div>
  )
}

